import { defineComponent, inject, ref, computed, createElementBlock, openBlock, Fragment, createElementVNode, createCommentVNode, mergeProps, normalizeClass, renderSlot, unref } from "vue";
import { colsInjectionKey, isFirstColFixedInjectionKey, isLastColFixedInjectionKey, isColsResizableInjectionKey } from "./p-table.js";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _hoisted_1 = {
  key: 0,
  class: "min-w-[80px] border-l border-p-gray-30 bg-gradient-to-r from-white via-p-gray-10 to-p-gray-10"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PTableTd", inheritAttrs: false },
  __name: "p-table-td",
  props: {
    colIndex: {},
    isEditable: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const cols = inject(colsInjectionKey, ref([]));
    const isFirstColFixed = inject(isFirstColFixedInjectionKey, ref(false));
    const isLastColFixed = inject(isLastColFixedInjectionKey, ref(false));
    const isColsResizable = inject(isColsResizableInjectionKey, ref(false));
    const isFirstCol = computed(() => props.colIndex === 0);
    const isSecondCol = computed(() => props.colIndex === 1);
    const isNextToLastCol = computed(() => props.colIndex === cols.value.length - 2);
    const isLastCol = computed(() => props.colIndex === cols.value.length - 1);
    const tdClass = computed(() => {
      const res = [
        // Common classes for all cells
        "p-0 h-full font-normal text-p-gray-60 text-sm "
      ];
      if (props.isEditable) {
        res.push("cursor-pointer");
      }
      if (isFirstColFixed.value && isFirstCol.value) {
        res.push("td-col-fixed-border-b");
        res.push("first:sticky first:left-0 first:z-10");
      } else if (isLastColFixed.value && isLastCol.value) {
        res.push("td-col-fixed-border-b", "last:sticky last:right-0 last:z-10");
      } else {
        res.push("border-b border-p-gray-30 border-r border-r-p-blue-10");
      }
      if (props.isSelected) {
        res.push("bg-p-blue-15 group-hover/row:bg-p-blue-15");
      } else {
        res.push("bg-white group-hover/row:bg-p-gray-10");
      }
      return res;
    });
    const innerDivClass = computed(() => {
      const res = [];
      const currentColIsFirstColFixed = isFirstColFixed.value && isFirstCol.value;
      const currentColIsLastColFixed = isLastColFixed.value && isLastCol.value;
      if (!currentColIsFirstColFixed && !currentColIsLastColFixed) {
        res.push("w-max");
      }
      if (currentColIsFirstColFixed) {
        res.push("td-shadow-right flex flex-col h-full justify-center px-3");
      } else if (currentColIsLastColFixed) {
        res.push("td-shadow-left flex flex-col h-full justify-center px-3");
      } else if (isFirstColFixed.value && isSecondCol.value) {
        res.push("pl-4 pr-2");
      } else if (isLastColFixed.value && isNextToLastCol.value) {
        res.push("pr-4 pl-2");
      } else {
        res.push("px-2");
      }
      return res;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("td", mergeProps({ class: tdClass.value }, _ctx.$attrs), [
          _cache[0] || (_cache[0] = createElementVNode("div", { class: "dropdown-anchor" }, null, -1)),
          createElementVNode("div", {
            class: normalizeClass(innerDivClass.value)
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 2)
        ], 16),
        unref(isColsResizable) && isLastCol.value && !unref(isLastColFixed) ? (openBlock(), createElementBlock("td", _hoisted_1)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const PTableTd = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c9978e26"]]);
export {
  PTableTd as default
};
